(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elsniva-cart-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elsniva-cart-editor')) {
  class ElsnivaCartEditor extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.selects=[...this.querySelectorAll('select')];
      this.button=this.querySelector('button');
      this.message=this.querySelector('[role="status"]');
      this.selects.forEach((select,index)=>select.addEventListener('change',()=>this.sync(index)));
      this.button.addEventListener('click',()=>this.save());
      this.sync(-1);
    }
    sync(changed) {
      this.selects.forEach((select,index)=>{
        const prefix=this.selects.slice(0,index).map(s=>s.value);
        for(const option of select.options) option.disabled=!this.variants.some(v=>v.available && v.options[index]===option.value && prefix.every((value,i)=>v.options[i]===value));
        if(index>changed && changed>=0 && select.selectedOptions[0]?.disabled) {
          const next=[...select.options].find(o=>!o.disabled);
          if(next)select.value=next.value;
        }
      });
      const choices=this.selects.map(select=>select.value);
      this.target=this.variants.find(v=>v.available && choices.every((value,index)=>v.options[index]===value));
      this.button.disabled=!this.target || String(this.target.id)===this.dataset.current;
      this.message.textContent=this.target?'':this.dataset.unavailable;
    }
    async save() {
      const drawer=this.closest('cart-drawer');
      if(!this.target || drawer.hasAttribute('data-avena-editing'))return;
      const root=window.Shopify.routes.root;
      const api=async(path,body)=>{
        const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}:{cache:'no-store'});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||'Cart update failed');
        return result;
      };
      const sectionIds=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sectionIds}}));
      const bundle={sections:[...new Set(sectionIds)].slice(0,5),sections_url:location.pathname};
      const publish=cart=>{
        if(cart.sections && Object.values(cart.sections).every(Boolean))document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      };
      const token=crypto.randomUUID();
      const label=this.button.textContent;
      drawer.setAttribute('data-avena-editing','');drawer.setAttribute('aria-busy','true');
      const locked=[...drawer.querySelectorAll('button,input,select')].filter(e=>!e.disabled);
      locked.forEach(e=>e.disabled=true);
      this.button.textContent=this.dataset.busy;this.message.textContent='';
      let original,removed=false;
      const matches=item=>item.variant_id===original.variant_id && JSON.stringify(item.properties||{})===JSON.stringify(original.properties||{}) && item.selling_plan_allocation?.selling_plan.id===original.selling_plan_allocation?.selling_plan.id;
      try {
        const before=await api('cart.js');
        original=before.items.find(item=>item.key===this.dataset.key);
        if(!original)throw new Error('Cart item changed');
        const replacement={id:this.target.id,quantity:original.quantity,properties:{...original.properties,_avena_edit:token}};
        if(original.selling_plan_allocation)replacement.selling_plan=original.selling_plan_allocation.selling_plan.id;
        await api('cart/add.js',{items:[replacement]});
        const interim=await api('cart.js');
        const old=interim.items.find(matches);
        if(!old)throw new Error('Cart item changed');
        const cart=await api('cart/change.js',{id:old.key,quantity:0,...bundle});
        removed=true;
        const edited=cart.items.find(item=>item.properties?._avena_edit===token);
        if(!edited || edited.quantity!==original.quantity || (original.properties?._avena_gift && edited.final_line_price!==0))throw new Error('Variant cannot retain gift offer');
        publish(cart);
      } catch(error) {
        try {
          if(removed && original) {
            const restore={id:original.variant_id,quantity:original.quantity,properties:original.properties};
            if(original.selling_plan_allocation)restore.selling_plan=original.selling_plan_allocation.selling_plan.id;
            await api('cart/add.js',{items:[restore]});
          }
          const current=await api('cart.js');
          const added=current.items.find(item=>item.properties?._avena_edit===token);
          if(added)publish(await api('cart/change.js',{id:added.key,quantity:0,...bundle}));
          this.message.textContent=this.dataset.error;
        } catch(restoreError) { location.href=root+'cart'; }
      } finally {
        drawer.removeAttribute('data-avena-editing');drawer.removeAttribute('aria-busy');
        locked.forEach(e=>e.disabled=false);this.button.textContent=label;
      }
    }
  }
  customElements.define('elsniva-cart-editor',ElsnivaCartEditor);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["szyk-mystery-gift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const opener=event.target.closest('[data-gift-open]');if(opener){const popup=opener.closest('.product-info__buy-buttons').querySelector('.szyk-gift-popup');if(popup&&!popup.open)popup.showModal();}const closer=event.target.closest('[data-gift-close]');if(closer)closer.closest('dialog').close();if(event.target.matches('.szyk-gift-popup')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["szyk-product-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('szyk-product-promo')) {
  customElements.define('szyk-product-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button[data-code]');
      const status = this.querySelector('[role="status"]');
      button.addEventListener('click', async () => {
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(button.dataset.code);
          button.textContent = button.dataset.copied;
          status.textContent = button.dataset.copied;
        } catch (error) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('.szyk-promo__code'));
          selection.removeAllRanges();
          selection.addRange(range);
          status.textContent = button.dataset.error;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["szyk-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-szyk-size-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.szykSizeOpen);
    if (dialog && !dialog.open) {
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      dialog.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'), { once: true });
    }
    return;
  }
  const closer = event.target.closest('[data-szyk-size-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('dialog.szyk-size-popup')) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  }
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-szyk-size-category]')) return;
  const dialog = event.target.closest('dialog');
  dialog.querySelectorAll('[data-szyk-size-panel]').forEach((panel) => { panel.hidden = panel.dataset.szykSizePanel !== event.target.value; });
});
  } catch(e) { console.error(e); }
})();

})();
